// frontend/src/services/api.js (RETTET VERSION)
import axios from 'axios';
import apiConfig from '../config/api';

const api = axios.create({
  baseURL: apiConfig.apiUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add JWT authentication
api.interceptors.request.use(
  (config) => {
    // Add JWT token if available
    const token = localStorage.getItem('authToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const status = error.response?.status;

    if (status === 401) {
      // If JWT token is invalid, clear it and redirect to login
      const token = localStorage.getItem('authToken');
      if (token) {
        localStorage.removeItem('authToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// API functions
export const productionAPI = {
  registerCasting: (data) => api.post('/production/register-casting', data),
  getBatches: (params) => api.get('/production/batches', { params }),
  getStatusOverview: () => api.get('/production/status-overview'),
  updateBatch: (batchId, data) => api.put(`/production/batches/${batchId}`, data),
  markBatchReady: (batchId) => api.put(`/production/batches/${batchId}/mark-ready`),
  deleteBatch: (batchId) => api.delete(`/production/batches/${batchId}`)
};

export const stockAPI = {
  getCurrent: () => api.get('/stock/current'),
  getLowStock: (threshold) => api.get('/stock/low-stock', { params: { threshold } }),
  getByProduct: (productId) => api.get(`/stock/by-product/${productId}`)
};

export const salesAPI = {
  createOrder: (data) => api.post('/sales/orders', data),
  getOrders: async (params) => {
    const res = await api.get('/sales/orders', { params });
    // Defensive: always return array
    if (res && Array.isArray(res.data?.data)) return res.data.data;
    if (res && Array.isArray(res.data)) return res.data;
    return [];
  },
  shipOrder: (orderId) => api.put(`/sales/orders/${orderId}/ship`),
  closeOrderWon: (orderId) => api.put(`/sales/orders/${orderId}/close-won`),
  closeOrderLost: (orderId, reason) => api.put(`/sales/orders/${orderId}/close-lost`, { reason }),
  getStatistics: (params) => api.get('/sales/statistics', { params }),
  // RETTET: Korrekt URL og tilføjet return statement
  updateOrder: (orderId, data) => api.put(`/sales/orders/${orderId}`, data),
  getStats: (range = 'week') => api.get('/sales/statistics', { params: { range } }),
  deleteOrder: (orderId) => api.delete(`/sales/orders/${orderId}`)
};

export const productsAPI = {
  getAll: () => api.get('/products'),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  createVariant: (productId, data) => api.post(`/products/${productId}/variants`, data),
  getVariants: (productId) => api.get(`/products/${productId}/variants`),
  updateVariant: (productId, variantId, data) => api.put(`/products/${productId}/variants/${variantId}`, data),
  deleteVariant: (productId, variantId) => api.delete(`/products/${productId}/variants/${variantId}`)
};

export const reportsAPI = {
  downloadInventoryReport: (startDate, endDate) =>
    api.get('/reports/inventory', {
      params: { startDate, endDate },
      responseType: 'blob'
    })
};

export default api;